export enum VendorQuoteColId {
  ARCHIVED = 'archived',
  CREATED_AT = 'createdAt',
  CUSTOMER_CORPORATE_USER_NAME = 'customerCorporateUserName',
  CUSTOMER_PROJECT_NAME = 'customerProjectName',
  EXTERNAL_CUSTOMER_NUMBER = 'externalCustomerNumber',
  EXTERNAL_ORDER_NUMBER = 'externalOrderNumber',
  EXTERNAL_PENDING_ORDER_NUMBER = 'externalPendingOrderNumber',
  FILENET_STATUS = 'filenetStatus',
  ID = 'id',
  JOB_NAME = 'jobName',
  LOCATION_NAME = 'locationName',
  MANUFACTURERS = 'manufacturers',
  PARENT_ID = 'parentId',
  PURCHASE_ORDER_NUMBER = 'purchaseOrderNumber',
  STATUS = 'status',
  TOTAL_PRICE = 'totalPrice',
  TRADE_AGREEMENT_OWNER_NAME = 'tradeAgreementOwnerName',
  TRADE_AGREEMENT_STATUS = 'tradeAgreementStatus',
  UPDATED_AT = 'updatedAt',
  VALID_UNTIL = 'validUntil',
  VENDOR_CONTACT_GROUP_NAME = 'vendorContactGroupName',
  VENDOR_CONTACT_NAME = 'vendorContactName',
  VENDOR_NAME = 'vendorName',
  VENDOR_PROJECT_NAME = 'vendorProjectName',
  VENDOR_QUOTE_NUMBER = 'vendorQuoteNumber',
}
